import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { UserRole } from '../../enums/user-role.enum';

@Injectable({
    providedIn: 'root'
})
export class RoleService {

    constructor(
        public msalService: MsalService
    ) { }

    getRole(): UserRole {
        if (this.msalService.instance.getActiveAccount()?.idTokenClaims?.roles?.includes(UserRole.SuperUser.valueOf())) {
            return UserRole.SuperUser;
        } else if (this.msalService.instance.getActiveAccount()?.idTokenClaims?.roles?.includes(UserRole.Contractor.valueOf())) {
            return UserRole.Contractor;
        } 
        return UserRole.NotAuthorized;
    }

    showAnalytics(role: UserRole): boolean { 
        switch (role) {
            case UserRole.SuperUser:
                return true;
            case UserRole.Contractor: 
                return false;
            default:
                return false;
        }
    }

    showInterventionTracker(role: UserRole): boolean { 
        switch (role) {
            case UserRole.SuperUser:
                return true;
            case UserRole.Contractor: 
                return true;
            default:
                return false;
        }
    }
}
